import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

export enum LANGUAGES {
  'en' = 'en',
  'zh' = 'zh',
  'hi' = 'hi',
  'es' = 'es',
  'pt' = 'pt',
  'fr' = 'fr',
  'ru' = 'ru',
  'tl' = 'tl',
  'id' = 'id',
  'tr' = 'tr',
  'el' = 'el',
  'de' = 'de',
  'cs' = 'cs',
  'it' = 'it',
}

export const defaultLanguage = LANGUAGES.en;

export const supportedLanguages: { [key in LANGUAGES]: string } = {
  [LANGUAGES.en]: 'English',
  [LANGUAGES.zh]: '中文',
  [LANGUAGES.hi]: 'हिन्दी',
  [LANGUAGES.tr]: 'Türkçe',
  [LANGUAGES.tl]: 'Tagalog',
  [LANGUAGES.es]: 'Español',
  [LANGUAGES.pt]: 'Português',
  [LANGUAGES.id]: 'Bahasa',
  [LANGUAGES.fr]: 'Français',
  [LANGUAGES.el]: 'Ελληνική',
  [LANGUAGES.it]: 'Italiano',
  [LANGUAGES.de]: 'Deutsch',
  [LANGUAGES.cs]: 'Česky',
  [LANGUAGES.ru]: 'Русский',
};

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    backend: {
      requestOptions: {
        cache: 'no-store',
      },
    },
    debug: false,
    fallbackLng: defaultLanguage,
    supportedLngs: Object.values(LANGUAGES).map((lng) => lng),
    load: 'currentOnly',
    lowerCaseLng: true,
    compatibilityJSON: 'v3',
  });

export default i18n;
